import React from 'react';

/**
 * DjamannLoader - Loader de marque utilisant le logo animé Djamann
 * 
 * Variantes :
 * - "fullscreen" : Plein écran (auth, transitions de route)
 * - "section"    : Section de page (chargement de données)
 * - "inline"     : Petit loader inline (dans un conteneur)
 */
const DjamannLoader = ({ variant = 'section', text, className = '' }) => {
  const sizes = {
    fullscreen: 'h-20 w-20',
    section: 'h-14 w-14',
    inline: 'h-8 w-8',
  };

  const logoSize = sizes[variant] || sizes.section;

  // Plein écran — utilisé pour l'auth et les transitions de route
  if (variant === 'fullscreen') {
    return (
      <div className={`min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex flex-col items-center justify-center ${className}`}>
        <div className="flex flex-col items-center gap-4">
          <img
            src="/logo_anime.gif"
            alt="Chargement Djamann"
            className={`${logoSize} object-contain`}
            draggable={false}
          />
          {text && (
            <p className="text-sm text-gray-500 font-medium animate-pulse">{text}</p>
          )}
        </div>
      </div>
    );
  }

  // Section — utilisé dans les pages pour le chargement de données
  if (variant === 'section') {
    return (
      <div className={`flex flex-col items-center justify-center py-16 ${className}`}>
        <img
          src="/logo_anime.gif"
          alt="Chargement"
          className={`${logoSize} object-contain`}
          draggable={false}
        />
        {text && (
          <p className="text-sm text-gray-400 mt-3">{text}</p>
        )}
      </div>
    );
  }

  // Inline — petit loader dans un conteneur
  return (
    <div className={`flex items-center justify-center gap-2 ${className}`}>
      <img
        src="/logo_anime.gif"
        alt="Chargement"
        className={`${logoSize} object-contain`}
        draggable={false}
      />
      {text && (
        <span className="text-sm text-gray-400">{text}</span>
      )}
    </div>
  );
};

export default DjamannLoader;
